var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 15.9886H3.6255C3.942 15.9886 4.2395 15.8656 4.463 15.6416L15.653 4.45162C15.8765 4.22812 16 3.93062 16 3.61412C16 3.29762 15.8765 3.00012 15.653 2.77662L13.212 0.335625C12.7645 -0.111875 11.9845 -0.111875 11.537 0.335625L0.3475 11.5251C0.1265 11.7451 0 12.0506 0 12.3631V15.4886C0 15.7646 0.224 15.9886 0.5 15.9886ZM3.6255 14.9892H1V12.3637C1 12.3147 1.0195 12.2682 1.054 12.2332L10.3879 2.89963L13.0897 5.60142L3.756 14.9352C3.721 14.9702 3.675 14.9892 3.6255 14.9892ZM13.7967 4.89442L11.095 2.19265L12.2445 1.04316C12.338 0.949156 12.411 0.949156 12.505 1.04316L14.946 3.48416C14.993 3.53116 15 3.58616 15 3.61466C15 3.64316 14.993 3.69816 14.946 3.74516L13.7967 4.89442ZM3.1004 13.7881C3.19841 13.9186 3.34841 13.9876 3.50041 13.9876C3.60491 13.9876 3.71041 13.9551 3.80041 13.8876C4.02091 13.7216 4.0654 13.4081 3.89941 13.1876C3.58691 12.7711 3.21691 12.4016 2.80041 12.0881C2.57941 11.9231 2.26641 11.9671 2.10041 12.1876C1.93441 12.4081 1.97891 12.7216 2.19941 12.8876C2.5409 13.1441 2.8439 13.4471 3.1004 13.7881Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5224_77190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 15.9886H3.6255C3.942 15.9886 4.2395 15.8656 4.463 15.6416L15.653 4.45162C15.8765 4.22812 16 3.93062 16 3.61412C16 3.29762 15.8765 3.00012 15.653 2.77662L13.212 0.335625C12.7645 -0.111875 11.9845 -0.111875 11.537 0.335625L0.3475 11.5251C0.1265 11.7451 0 12.0506 0 12.3631V15.4886C0 15.7646 0.224 15.9886 0.5 15.9886ZM3.6255 14.9892H1V12.3637C1 12.3147 1.0195 12.2682 1.054 12.2332L10.3879 2.89963L13.0897 5.60142L3.756 14.9352C3.721 14.9702 3.675 14.9892 3.6255 14.9892ZM13.7967 4.89442L11.095 2.19265L12.2445 1.04316C12.338 0.949156 12.411 0.949156 12.505 1.04316L14.946 3.48416C14.993 3.53116 15 3.58616 15 3.61466C15 3.64316 14.993 3.69816 14.946 3.74516L13.7967 4.89442ZM3.1004 13.7881C3.19841 13.9186 3.34841 13.9876 3.50041 13.9876C3.60491 13.9876 3.71041 13.9551 3.80041 13.8876C4.02091 13.7216 4.0654 13.4081 3.89941 13.1876C3.58691 12.7711 3.21691 12.4016 2.80041 12.0881C2.57941 11.9231 2.26641 11.9671 2.10041 12.1876C1.93441 12.4081 1.97891 12.7216 2.19941 12.8876C2.5409 13.1441 2.8439 13.4471 3.1004 13.7881Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5224_77190)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.4444,
    height: 28.4444,
    fill: "#8A8E96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilGrey);
export default __webpack_public_path__ + "static/media/pencil-grey.c082d4d3f37d1c4a9c1ae5b0f72877b8.svg";
export { ForwardRef as ReactComponent };